<template>
  <div class="footer-container">
    <div class="footer-wrap">
      <div class="left">
        <!-- <div class="left-1">
          <h4>主办单位</h4>
          <p>深圳市人民政府</p>
          <p>鹏城实验室(PCNL)</p>
        </div> -->
        <div class="left-2">
          <div class="box">
            <h4>主办单位</h4>
            <p>深圳市科技创新委员会</p>
            <p>鹏城实验室</p>
          </div>
          <div class="box">
            <h4>承办单位</h4>
            <p>新一代人工智能产业技术创新战略联盟(AITISA)</p>
          </div>
          <!-- <div class="box">
            
          <h4>支持单位</h4>
          <p>广东省人工智能与机器人学会</p>
          </div> -->
        </div>
        <div class="left-3">
          <h4>协办单位</h4>
          <div class="box">
            <p>中国工商银行股份有限公司深圳市分行</p>
            <p>华为技术有限公司</p>
            <!-- <p>中国农业银行股份有限公司深圳市分行</p> -->
            <!-- <br> -->
            <p>深圳市鹏城实验室科教基金会</p>
          </div>
        </div>
        <div class="left-4">
          <h4>支持单位</h4>
          <p>广东省人工智能与机器人学会</p>
        </div>
      </div>
      <div class="right">
        <h4>关注公众号</h4>
        <div class="qrcode">
          <img src="../assets/naic/qrcode.png" />
        </div>
      </div>
    </div>
    <div class="copyright-wrap">
      <p>
        办赛联系方式： naic@pcl.ac.cn | Copyright 2021 鹏城实验室. All Right
        Reserved. ｜ 粤ICP备18066427号
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "footer",
  };
</script>

<style scoped lang="scss">
  .footer-container {
    width: 100%;
    height: 294px;
    background: #000;
    .footer-wrap {
      width: 970px;
      height: 211px;
      display: flex;
      margin: 0 auto;
      // justify-content: space-between;
      padding-top: 20px;
      padding-bottom: 20px;
      h4 {
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #f6f7fa;
        line-height: 36px;
      }
      .left {
        // display: flex;
        // justify-content: flex-start;
        width: 810px;

        p {
          line-height: 34px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #9d9d9d;
        }
        .left-1 {
          width: 174px;
        }
        .left-2 {
          // width: 324px;
          display: flex;
          .box {
            width: 500px;
            p {
              display: inline-block;
              margin-right: 20px;
            }
          }
        }
        .left-3 {
          // width: 211px;
          // padding-left: 50px;
          // padding-top: 20px;
          .box {
            // display: flex;
            p {
              display: inline-block;
              // width: 270px;
              margin-right: 20px;
            }
          }
        }
        // .left-4 {
        //   width: 284px;
        // }
      }
      .right {
        border-left: 1px solid #434343;
        padding-left: 60px;
        height: 158px;
        h4 {
          text-align: center;
        }
        img {
          width: 102px;
          height: 102px;
        }
      }
    }
    .copyright-wrap {
      max-width: 970px;
      height: 44px;
      margin: 0 auto;
      box-sizing: border-box;
      border-top: 1px solid #434343;
      p {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #717171;
        line-height: 44px;
        text-align: center;
      }
    }
  }
</style>
